<template>
  <div class="map-config">
    <!-- <div class="full-filters-header">
      <div class="full-filters-title">{{ $t('tooltip_edit_chart') }}</div>
      <div class="full-filters-close-icon" @click="toggleEdit" />
    </div> -->
    <!-- {{ internalValue }} -->
    <div class="edit-wrapp-options">
      <!-- <ColorPickerInput v-model="colorPicked" :options="colorsObject" />
      <RadioScaleInput
        v-model="internalValue.scaleOption"
        :color-range="internalValue.colorRange"
        :default-map-steps="internalValue.scaleSteps"
        @change-num-steps="changeNumSteps"
        @change-interpolation="changeInterpolation"
      />
      <OpacityRangeInput v-model="internalValue.opacityMapValue" />
      <div class="title">{{ $t('chart_legend_title') }}</div>
      <CheckboxInput v-model="internalValue.hasLegend" text="chart_legend" /> -->
      <ColorScaleInput v-model="internalValue" :all-time-values="allTimeValues" />
      <div class="title">{{ $t('chart_legend_title') }}</div>
      <CheckboxInput v-model="internalValue.hasLegend" text="chart_legend" />
    </div>
  </div>
</template>

<script>
import ColorScaleInput from './ColorScaleInput.vue'
// import OpacityRangeInput from './OpacityRangeInput.vue'
import CheckboxInput from '../charts/CheckboxInput.vue'
// import RadioScaleInput from './RadioScaleInput.vue'
// import {ticks as d3_ticks } from 'd3-array';
// import { format as d3_format } from 'd3-format'

// import { cssGradient, MAP_COLORS } from '../../utils/colorUtils'
export default {
  components: { ColorScaleInput, CheckboxInput },
  model: {
    prop: 'config',
    event: 'change',
  },
  props: {
    config: Object,
    allTimeValues: Array,
  },
  data() {
    return {
      internalValue: null,
    }
  },
  watch: {
    config: {
      handler(value) {
        let tmp = JSON.parse(JSON.stringify(value))
        this.internalValue = tmp
      },
      immediate: true,
      deep: true,
    },
    internalValue: {
      handler(value) {
        if (JSON.stringify(value) !== JSON.stringify(this.config)) this.$emit('change', value)
      },
      deep: true,
    },
  },
}
</script>

<style lang="stylus" scoped>
.map-config
  padding: vw(10px) vw(20px)
  background: #fff

  .edit-wrapp-options
    .title
      m-font-size(14, 20)
      margin-bottom: vw(10px)
      font-weight: 600
</style>
